import { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { PieChart } from '@mui/x-charts/PieChart';
import moneyFormat from '../functions/moneyFormat';
import Skeleton from '@mui/material/Skeleton';
import { blueberryTwilightPalette } from '@mui/x-charts/colorPalettes';

const SpendPieChart = ({ tags, data, onClick, isLoading, colors}) => {
    // initialize state
    const [series, setSeries] = useState([{
        innerRadius: 0, 
        outerRadius: 80, 
        id: 'Loading',  
        data: [ { label: 'Loading', value: 1 } ], 
    }]); 
    const [height, setHeight] = useState(400); 
    const [width, setWidth] = useState(300); 
    const [colorPallete, setColorPallete] = useState(); 

    // useEffect to run on initial render and data change 
    useEffect(() => {
        if (data.length > 0) {
            let tempSeries = []; 
            // put data in pie chart obj
            for (let i = 0; i < data.length; i++) {
                let inner, outer; 
                // calculate inner and outer radius
                if ( i == 0 ) {
                    inner = 95; 
                    // outer = 90;
                    outer = 130; 
                }
                else {
                    // inner = 100 + ((i-1) * 40); 
                    // outer = 130 + ((i-1) * 40); 
                    inner = 140 + ((i-1) * 40); 
                    outer = 170 + ((i-1) * 40); 
                }
                // specify data object 
                let dataList = []; 
                for (let n = 0; n < data[i].length; n++) {
                    let label = ''; 
                    for (let k = i; k >=0; k--) {
                        if (k == i) {
                            label = data[i][n][tags[k]]; 
                        }
                        else {
                            label = data[i][n][tags[k]]  + ' | ' + label ; 
                        }
                    }
                    let dataObj = {
                        value: data[i][n]['value'],
                        label: label,
                    }
                    dataList.push(dataObj); 
                }
                 
                // specify temp obj
                let temp = {
                    innerRadius: inner, 
                    outerRadius: outer, 
                    paddingAngle: 3, 
                    cornerRadius: 5, 
                    id: tags[i], 
                    data: dataList, 
                    valueFormatter: (value) =>{ return moneyFormat(value['value']) }, 
                    
                }
                // if (i == 0) {
                //    temp['arcLabel']= (item) => `${item.label}`; 
                // }
                // set height and width
                setHeight(height => height = (outer * 3) + 10); 
                setWidth(width => width = (outer * 2) + 10); 
                // push into array 
                tempSeries.push(temp);
            }
            // set state 
            setSeries(series => series = tempSeries); 
        }
    }, [data]); 

    // useEffect to run on colors change 
    useEffect(() => {
        if (colors && colors.length > 0){
            setColorPallete(colorPallete => colorPallete = colors); 
        }
        else {
            setColorPallete(colorPallete => colorPallete = blueberryTwilightPalette); 
        }
    }, [colors]); 
    
    return (
        <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 0, md: 4 }}
            sx={{ width: '100%' }}
        >
            { series.length > 0 ? 
            <Box sx={{ flexGrow: 1 }}>
                { isLoading ? 
                <> 
                    <Skeleton variant="circular" width={270} height={270} sx={{margin:'auto'}}/>
                </>
                :<PieChart
                    series={series}
                    // width={height}
                    height={width}
                    slotProps={{
                        // legend: { hidden: true },
                    }}
                    loadining={isLoading}
                    onItemClick={onClick}
                    sx={{
                        width: '90%'
                    }}
                    colors={colorPallete}
                />}
            </Box>
            :<></> } 
        </Stack> 
    )
}

export default SpendPieChart; 